"use strict";
var moment = require("moment");
var constants_1 = require("./constants");
function departureDateValidator(maxDate, minDate, overrideValidation) {
    if (maxDate === void 0) { maxDate = null; }
    if (minDate === void 0) { minDate = null; }
    if (overrideValidation === void 0) { overrideValidation = false; }
    return function (control) {
        // departure date must be a valid date
        var value = control.value;
        if (value && value !== '') {
            var dateValue = moment(value, constants_1.Constants.DATE_PARSE_FORMAT);
            if (!dateValue.isValid()) {
                return { 'invalid': value };
            }
            // departure date must be on or before max date
            if (maxDate) {
                var maxValue = moment(maxDate, constants_1.Constants.DATE_PARSE_FORMAT);
                if (maxValue.isValid() && dateValue.startOf('day').isAfter(maxValue.startOf('day'))) {
                    return { 'afterMax': value };
                }
            }
            // departure date must be on or before max date
            if (minDate) {
                var minValue = moment(minDate, constants_1.Constants.DATE_PARSE_FORMAT);
                if (minValue.isValid() && dateValue.startOf('day').isBefore(minValue.startOf('day'))) {
                    return { 'beforeMin': value };
                }
            }
            if (!overrideValidation) {
                // departure date must be after today
                if (dateValue.startOf('day').isSameOrBefore(moment().startOf('day'))) {
                    return { 'beforeToday': value };
                }
            }
        }
        return null;
    };
}
exports.departureDateValidator = departureDateValidator;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/departure-date.validator.js